import styled from 'styled-components';

import { ModalContainerStyle } from '../../../../components/common/modal-container/modal-container-style';

export const ChatStyle = styled.div`
  #DIV_ID {
    height: calc(100vh - 64px);
  }

  .imbee-chat-messages ul li > div.me > div.imbee-message > div.imbee-text-time {
    background-color: red !important;
  }

  ${ModalContainerStyle} {
    .modal-children {
      margin-bottom: 0;
    }
    .modal-content {
      padding: 0;
    }

    .c-chatbot__body__actions__send-button {
      border: 3px solid blue;
    }
  }
`;
